import { useEffect } from 'react';

/**
 * Close-on-Escape for a layer.
 *
 * `enabled` exists for stacked layers: every caller listens on `document`, so
 * an inner layer being open must disable the outer one's handler or a single
 * keypress closes both.
 *
 * @param {boolean} enabled false to ignore Escape while another layer owns it
 * @param {() => void} onEscape
 */
export const useEscapeKey = (enabled, onEscape) => {
  useEffect(() => {
    if (!enabled) return undefined;
    const onKeyDown = (e) => { if (e.key === 'Escape') onEscape(); };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [enabled, onEscape]);
};

export default useEscapeKey;
